var _defs, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRetroviseurCasse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 3000 3000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#bc3c2b;}.cls-3{clip-path:url(#clip-path);}.cls-4{fill:#5a6168;}.cls-5{fill:#868d93;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1275.54,1535.2s-48.43-13.5-56-18.58-12.44-6.75-11.34-23,4-62,6.07-69.9,10.56-18.08,23.31-21.54,57.9-11.89,61.32-14.52a122.09,122.09,0,0,1,11.52-9.76c9.55.07,34.25,4.48,50,10.18-5.36,46.28-13.73,112-16.72,119.16C1339.27,1517.93,1329.67,1544.33,1275.54,1535.2Z"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "illustration 1 r\xE9troviseur r\xE9par\xE9") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_9",
    "data-name": "Calque 9"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1,
    y: 1,
    width: 2999,
    height: 2999
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "\\xE9l\\xE9ments_cliquables",
    "data-name": "\\xE9l\\xE9ments cliquables"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1344,1387.59s10.15-19.3,21.33-16.25c2-9.14,0-10.16,0-10.16s-26.41,16.25-27.43,26.41S1344,1387.59,1344,1387.59Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1275.54,1535.2s-48.43-13.5-56-18.58-12.44-6.75-11.34-23,4-62,6.07-69.9,10.56-18.08,23.31-21.54,57.9-11.89,61.32-14.52a122.09,122.09,0,0,1,11.52-9.76c9.55.07,34.25,4.48,50,10.18-5.36,46.28-13.73,112-16.72,119.16C1339.27,1517.93,1329.67,1544.33,1275.54,1535.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1223.1,1412s-.83,86.19,3.09,91.39,68.31,28.34,115.45,14.42c11.4-3.37-42.78,39.45-42.78,39.45L1203.33,1521l3.31-117.8Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1360.2,1334.77c3-10.16,9.14-14.23,16.25-14.23s17.27,2,21.34,5.08,10.16,6.1,13.2,10.16,4.07,33.53,0,39.62-3,10.16-14.22,11.18c-3.07.27-16.12.63-33.66.94C1362.23,1371.34,1362.23,1357.12,1360.2,1334.77Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Calque_8",
    "data-name": "Calque 8"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 2999,
    height: 2999
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetroviseurCasse);
export default __webpack_public_path__ + "static/media/retroviseur_casse.73c43a67d9a7f9cf1270897ba5615109.svg";
export { ForwardRef as ReactComponent };